import { Injectable } from '@angular/core';
import { NotificationEventResponse } from '@views/secure/notifications/store/notifications.model';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SseService {
  hasUpdatedNotification = new Subject<void>();
  eventSource: EventSource;

  private getEventSource(url: string): EventSource {
    const options: EventSourceInit = {
      withCredentials: false,
    };
    return new EventSource(url, options);
  }

  private closeServerSentEvent(): void {
    this.eventSource?.close();
    this.eventSource = undefined;
  }

  public getServerSentEvent(url: string): Observable<NotificationEventResponse> {
    this.closeServerSentEvent();

    this.eventSource = this.getEventSource(url);

    return new Observable<NotificationEventResponse>((subscriber) => {
      this.eventSource.addEventListener('notification', (event: MessageEvent<string>) => {
        subscriber.next(<NotificationEventResponse>JSON.parse(event.data));
        this.hasUpdatedNotification.next();
      });

      this.eventSource.onerror = (error) => {
        subscriber.error(error);
      };

      return () => {
        this.closeServerSentEvent();
      };
    });
  }
}
